import { cn } from '@/lib/utils'
import { Period } from './types'

type HourDropdownProps = {
  hour: number
  is24Hour: boolean
  period: Period
  onHourChange: (value: number) => void
  onClose: () => void
}

export function HourDropdown({ hour, is24Hour, period, onHourChange, onClose }: HourDropdownProps) {
  const hourOptions = Array.from({ length: is24Hour ? 24 : 12 }, (_, i) => {
    let label

    if (is24Hour) {
      label = i.toString().padStart(2, '0')
    } else {
      if (i === 0) {
        label = '12'
      } else {
        label = i.toString().padStart(2, '0')
      }
    }

    return { value: i, label }
  })

  return (
    <div className="absolute top-full z-10 mt-1 max-h-48 w-full overflow-y-auto rounded border bg-white shadow-lg">
      {hourOptions.map((hourOption) => (
        <div
          key={hourOption.value}
          className={cn(
            'px-3 py-1 hover:bg-gray-1 cursor-pointer text-xs',
            hour === hourOption.value && 'bg-gray-1',
          )}
          onClick={() => {
            let newHour

            if (is24Hour) {
              newHour = hourOption.value
            } else if (period === Period.PM && hourOption.value !== 12) {
              newHour = hourOption.value + 12
            } else {
              newHour = hourOption.value
            }
            onHourChange(newHour)
            onClose()
          }}
        >
          {hourOption.label}
        </div>
      ))}
    </div>
  )
}
